import { render, staticRenderFns } from "./chart-bar-percent.vue?vue&type=template&id=f6a22088"
import script from "./chart-bar-percent.vue?vue&type=script&lang=js"
export * from "./chart-bar-percent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports